<script setup lang="ts">
import { ref } from 'vue'
import { FilterField, TableField } from "../../../../components/table/table";
import ItemPricesForm from './ItemPricesForm.vue'
import ListTemplate from "../../../../components/ui/common/ListTemplate.vue";
import Buttons from '../../../../components/ui/form/Buttons.vue';
import { Permission } from '../../../../types/auth'

withDefaults(defineProps<{
  showHeader?: boolean,
  showQuickTour?: boolean,
  showTitle?: boolean,
  showNextButton?: boolean
}>(), {
  showHeader: true,
  showQuickTour: true,
  showTitle: true
})

defineEmits<{
  (e: "next"): void;
}>();


const endPoint = '/clients/inventory/item-management/item-prices/'
const title = 'Item Prices'
const selectedData = ref<any | null>(null)
const showForm = ref(false)
const formMode = ref<'create' | 'edit' | 'view' | 'showQuickView' | 'toggleStatus'>('view')
const refreshData = ref(false)

const fields = ref<TableField[]>([
  { name: 'photo', caption: 'Photo', sortable: true, fieldType: 'image' },
  { name: 'code', caption: 'Code', sortable: true, fieldType: 'text' },
  { name: 'name', caption: 'Name', sortable: true, fieldType: 'text' },
  { name: 'active', caption: 'active', sortable: false, fieldType: 'status' },
])

const filterFields: FilterField[] = [
  {
    name: 'active',
    label: 'Status',
    type: 'select',
    value: '',
     options: [
      { id: "1", name: "Active" },
      { id: "0", name: "Inactive" },
    ],
  },
]

const changeMode = (
  mode: "create" | "edit" | "view" | "showQuickView" | "toggleStatus"
) => {
  formMode.value = mode;
  showForm.value = mode === "view" || mode === "edit" || mode === "create";
};

const permissions = ref<Permission[]>([])
const handleData = (data : any) => {
  selectedData.value = data
  formMode.value = 'edit';
  showForm.value = true;
}

const dataLoaded = (data: any[]) => {
  if (data && data.length > 0) {
    const field: TableField[] = [];
    const columnNames = Object.keys(data[0]).filter(key => key !== "id");
    field.push({
          name: 'photo',
          caption: 'Photo',
          sortable: false,
          fieldType: "image",
        });
    columnNames.forEach((col) => {
      if (col.endsWith('_id') || col == "uid") {
        return;
      }
      if (col != "code" && col != "name" && col != "photo") {
        field.push({
          name: col,
          caption: col,
          sortable: false,
          fieldType: "number",
        });
      } else if (col != "photo") {
        field.push({
          name: col,
          caption: col,
          sortable: false,
          fieldType: "text",
        });
      }
    });
    fields.value = field
  }
}
</script>

<template>
  <ListTemplate :end-point= "endPoint" :custom-url= "'/clients/inventory/item-management/items/prices'" :page-size="100" :title = "title" :fields = "fields" 
  :actions = "[]" 
  :filterFields ="filterFields"
  :tabList = "[]" :refreshData = "refreshData" @mode="changeMode" @show="showForm = true" :showForm="showForm" 
  @data="handleData" @data-loaded="dataLoaded" :show-header="showHeader" :show-quick-tour="showQuickTour" :show-title="showTitle" @permissions="(data) => permissions = data">
  <template #header-actions>
    <Buttons v-if="showNextButton" icon="CircleArrowRight" caption="Next" @click="$emit('next')" />
  </template>
  <template #form-view>
    <ItemPricesForm
      v-if="showForm"
      :data="selectedData"
      :end-point="endPoint"
      :title="title"
      :mode="formMode"
      @save="refreshData = !refreshData"
      @close="showForm = !showForm"
    />
  </template>
  </ListTemplate>
</template>